import { render, staticRenderFns } from "./CourseSelector.vue?vue&type=template&id=499fa718&scoped=true"
import script from "./CourseSelector.vue?vue&type=script&lang=js"
export * from "./CourseSelector.vue?vue&type=script&lang=js"
import style0 from "./CourseSelector.vue?vue&type=style&index=0&id=499fa718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499fa718",
  null
  
)

export default component.exports